import { FormGroup } from "@angular/forms";
import { ValidationContext } from "@cv-invision/cv.invision-views.ux";

export const INSIDE_MAPS_FORM_CONFIG = {
	insideMaps: {
		enabled:{
			path: 'insideMaps.enabled',
			DataType: 'Boolean',
			DisplayText: `Enable InsideMaps(Creates an IM Project and attach to the inspection)`,
			Name: 'insideMaps.enabled',
			customClass: 'product-form-switch ms-5 mt-4 mb-4',
			required:false,
			Visible: function(control, jsonModelService: ValidationContext) {
				const comparedValue = jsonModelService.FindRootValue('inspection.softwareCollector');
				return comparedValue === 'InsideMaps' || false;
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, extraData: any) => {
					if(!$event.checked){
						formGroup.get('insideMaps.insideMapsId')?.setValue(null);
						formGroup.get('insideMaps.insideMapsName')?.setValue(null);
						formGroup.get('insideMaps.sendListingLink')?.setValue(false);
						formGroup.get('insideMaps.sendPropertyReportPageLink')?.setValue(false);
						formGroup.get('insideMaps.insideMapsFee')?.setValue(null);
					}
					formGroup.get('insideMaps').updateValueAndValidity();
				},
			},
		},
		sendListingLink:{
			path: 'insideMaps.sendListingLink',
			DataType: 'Boolean',
			DisplayText: `Send Listing Link to Integration?`,
			Name: 'insideMaps.sendListingLink',
			customClass: 'product-form-switch ms-5 mt-4 mb-4',
			required: false,
			Visible: function(control, jsonModelService) {
				const comparedValue = jsonModelService.FindValue('enabled');
				return comparedValue || false;
			}
		},
		sendPropertyReportPageLink:{
			path: 'insideMaps.sendPropertyReportPageLink',
			DataType: 'Boolean',
			DisplayText: `Send Property Report Page Link to Integration?`,
			Name: 'insideMaps.sendPropertyReportPageLink',
			customClass: 'product-form-switch ms-5 mt-4 mb-4',
			required:false,
			Visible: function(control, jsonModelService) {
				const comparedValue = jsonModelService.FindValue('enabled');
				return comparedValue || false;
			}
		},
		insideMapsId:{
			DataType: 'Selector',
			path: 'insideMaps.insideMapsId',
			UIControl: 'Dropdown',
			DisplayText: 'Software Collector Package',
			label: 'Software Collector Package',
			Name: 'insideMaps.insideMapsId',
			customClass: 'product-form-dropdown mt-3',
			options: [],
			UIOptions: {
				ShowClearButton: true,
				showLabel: true,
			},
			required: false,
			/*isRequired: function(control, jsonModelService) {
				return jsonModelService.IsEmpty() && jsonModelService.FindValue('enabled');
			},*/
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: FormGroup, formConfigModel: any) => {
					const value = $event.value;
					if (value !== '' && value !== null && value !== undefined) {
						const indexSelectedOption = formConfigModel.options.findIndex(element => element.value === value);
						const selectedOption = formConfigModel.options[ indexSelectedOption ];
						formGroup.get('insideMaps.insideMapsName')?.setValue(selectedOption.label);
					} else {
						formGroup.get('insideMaps.insideMapsId')?.setValue(null);
						formGroup.get('insideMaps.insideMapsName')?.setValue(null);
						formGroup.get('insideMaps.sendListingLink')?.setValue(false);
						formGroup.get('insideMaps.sendPropertyReportPageLink')?.setValue(false);
						formGroup.get('insideMaps.insideMapsFee')?.setValue(null);
					}
					formGroup.get('insideMaps').updateValueAndValidity();
				},
			},
		},
		insideMapsName:{
			DataType: 'String',
			path: 'insideMaps.insideMapsName',
			DisplayText: 'Software Collector Package',
			Name: 'insideMaps.insideMapsName',
			hidden: true,
			required: false
		},
		insideMapsFee:{
			path: 'insideMaps.insideMapsFee',
			DataType: 'Integer',
			DisplayText: 'Software Collector Fee',
			Name: 'insideMaps.insideMapsFee',
			customClass: 'mt-4 mb-4',
			min: 0,
			required: false
		},
	}
};
